import $ from 'jquery';
import LP from '../0-lp';


// =============== //
// QUESTION DIALOG //
// =============== //
LP.dlgQuestion = {
    questionDlg: null,
    storedTabText: '',
    curQuestionType: '',
    orgAfterSubmit: null,
    orgBeforeSubmit: null,

    prepare: function (selector, params) {
        LP.dlgQuestion.orgAfterSubmit = params.afterSubmit;
        LP.dlgQuestion.orgBeforeSubmit = params.beforeSubmit;
        $(selector).click(function () {
            if ($(this).is('[disabled]')) {
                return false;
            }

            setTimeout(() => {
                LP.dlgQuestion.questionDlg = LP.Dialog.open($.extend(params, {
                    name: 'question',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 970,
                    height: 680,
                    sizeable: false,
                    onLoad: LP.dlgQuestion.onLoad,
                    beforeSubmit: LP.dlgQuestion.beforeSubmit,
                    afterSubmit: LP.dlgQuestion.afterSubmit,
                    onClose: LP.dlgQuestion.onClose,
                    dialogClass: 'lp-tabs-vertical'
                }));
            }, 250);

            return false;
        });
    },

    onLoad: function () {
        LP.dlgQuestion.curQuestionType = $('#questionType').attr('value');
        // LP.dlgQuestion.loadQuestionForm($('#questionType').attr('value'));
        LP.dlgQuestion.onTabsLoaded();
    },

    onClose: function () {
        var itemId = $('#questionId').val();
        window.Browser.send('backend/closeEditDialog/', 'itemId=' + itemId);
        return false;
    },

    beforeSubmit: function (json) {
        LP.Dialog.hideErrors();

        var result = LP.dlgQuestion.saveQuestionTab(false);
        if (LP.dlgQuestion.orgBeforeSubmit) {
            LP.dlgQuestion.orgBeforeSubmit(json);
        }

        return result;
    },

    afterSubmit: function (json) {
        $('#questionId').attr('value', json.questionId);

        if (LP.dlgQuestion.orgAfterSubmit) {
            LP.dlgQuestion.orgAfterSubmit(json);
        }

        LP.Dialog.reloadTab();

        return true;
    },

    saveQuestionTab: function (refresh) {
        var questionForm = $('#questionForm');
        var tabResult = false;
        var url = 'backend/saveQuestionTab/';
        var params = questionForm.serializeObject();
        if (refresh) {
            params['refresh'] = 1;
        }

        const $panel = questionForm.find('#qTab_' + params.tabname);
        $panel.timedLoader(0); // sieht man nich so gut, wegen der sync-browser-requests
        window.Browser.send(
            url,
            params,
            function () {
                LP.Dialog.hideErrors();
                $panel.timedLoader(false);
                tabResult = true;
                return true;
            },
            function (json) {
                LP.Dialog.showError(json, $('.tabError'), false);
                $panel.timedLoader(false);
                tabResult = false;
                return true;
            },
            false
        );
        return tabResult;
    },

    onTabsLoaded: function () {
        // is nich schön, aber wg jquery update:
        // alle tabs, die nich über ajax geladen werden müssen direkt initialisiert werden
        LP.commentsDlg.initButtons(); // comments
        LP.questionTab.visibility.onLoad(); // visibility

        switch (LP.dlgQuestion.curQuestionType) {
            case 'CHOICE' :
                LP.choiceQuestion.initNonAjaxTabs();
                break;
            case 'INPUT'  :
                LP.inputQuestion.initNonAjaxTabs();
                break;
            case 'MATRIX' :
                LP.matrixQuestion.initNonAjaxTabs();
                break;
            case 'RANKING':
                LP.rankingQuestion.initNonAjaxTabs();
                break;
            case 'SCALE'  :
                LP.scaleQuestion.initNonAjaxTabs();
                break;
        }

        if ($('a[action="editQuestion"]').length === 1) {
            $('a[action="editQuestion"]').button().click(function () {
                LP.dlgQuestion.editInput($('input[name="question[question]"]'), $('a[action="editQuestion"]'));
            });
        }

        $('a.visibilityItem').each(function (index, item) {
            LP.questionTab.itemVisibility.prepare(item);
        });

        LP.Dialog.initTabs({
            name: '#lp-content-dialog',
            cache: false,
            onTabLoaded: LP.dlgQuestion.onTabLoaded,
            beforeTabChanged: LP.dlgQuestion.beforeTabChanged,
            afterTabChanged: LP.dlgQuestion.afterTabChanged,
            vertical: true
        });
    },

    beforeTabChanged: function (ui, refresh) {
        var tabname = LP.Dialog.getTabName();
        if (tabname === 'visibility') {
            LP.filters.removeEmptyTerms($('#fs-question-visibility'));
        }

        var tabResult = true;
        if (tabname === 'comments') {
            tabResult = LP.commentsDlg.askDiscard();
        } else {
            tabResult = LP.dlgQuestion.saveQuestionTab(refresh);
        }
        return tabResult;
    },

    afterTabChanged: function () {
        return true;
    },

    onTabLoaded: function (ui, tabname) {
        tabname = LP.Dialog.getTabName();

        var tab = $('#qTab_' + tabname);
        if (tab && tab.hasClass('lp-qtab-preloaded') && tab.hasClass('lp-qtab-inited')) {
            return;
        } // Skip preloaded tabs if already initialised

        switch (LP.dlgQuestion.curQuestionType) {
            case 'CHOICE' :
                LP.choiceQuestion.onLoad();
                break;
            case 'INPUT'  :
                LP.inputQuestion.onLoad();
                break;
            case 'MATRIX' :
                LP.matrixQuestion.onLoad();
                break;
            case 'RANKING':
                LP.rankingQuestion.onLoad();
                break;
            case 'SCALE'  :
                LP.scaleQuestion.onLoad();
                break;
        }

        if (tab) {
            tab.addClass('lp-qtab-inited');
        }
    },

    editInput: function (input, anchor) {
        var href = 'backend/openTextEditor/';
        var text = encodeURIComponent(input.val());
        var params = 'poll=' + $('#pollId').val() + '&text=' + text + '&mode=edit';
        LP.UI.openTextEditor(href, params, input, 'itemTextEditor', $(anchor).attr('title'), false, false);
    },

    initDefaultTextInputs: function () {
        const defaultInputTextDivs = document.querySelectorAll('.text-input-default');
        Array.from(defaultInputTextDivs).forEach((defaultInputTextDiv) => {
            if (!defaultInputTextDiv.getAttribute('data-init')) {
                window.reactPortals.addReactTextInputField(defaultInputTextDiv);
                defaultInputTextDiv.setAttribute('data-init', true);
            }
        });
    },

    toggleFixPos: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) {
            return false;
        }
        var $input = $('input', $this.parent());
        var fixed = $input.attr('value') !== '1';
        $input.attr('value', fixed ? 1 : 0);
        $this.toggleClass('icon-pin', fixed).toggleClass('icon-pin-1', !fixed);
        return true;
    },

    toggleInputType: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) {
            return false;
        }
        var $input = $('input', $this.parent());
        var hasinput = $input.attr('value') !== '1';
        $input.attr('value', hasinput ? 1 : 0);
        var parent = $this.closest('li');
        $this.toggleClass('green', hasinput);

        if (hasinput) {
            $('.lp-input-text', parent).css('width', '300px');
            $('.lp-container-inputtype', parent).fadeIn('fast');
        } else {
            $('.lp-container-inputtype', parent).fadeOut('fast', function () {
                $('.lp-input-text', parent).css('width', '450px');
            });

        }
        return true;
    },

    addGroup: function (newGroup, groups, callback) {
        if (newGroup.length !== 0) {
            var newGr = $(newGroup.html());//.replace(/preInputButton/g, 'inputButton').replace(/preFixButton/g, 'fixButton'));
            $('.lpjs-trigger', newGr).removeAttr('disabled');
            groups.append(newGr);
            callback(newGr);
        }
    },

    addGroupHere: function (newGroup, me, callback) {
        if (newGroup.length !== 0) {
            var newGr = $(newGroup.html());//.replace(/preInputButton/g, 'inputButton').replace(/preFixButton/g, 'fixButton'));
            newGr.insertAfter(me);
            $('.lpjs-trigger', newGr).removeAttr('disabled');

            callback(newGr);
        }
    },

    addOption: function (newGroup, group, callback) {
        if (newGroup.length !== 0) {
            var newOption = $($('ul', newGroup).html());//.replace(/preInputButton/g, 'inputButton').replace(/preFixButton/g, 'fixButton'));
            group.append(newOption);
            $('.lpjs-trigger', newOption).removeAttr('disabled');
            callback(newOption);
        }
    },

    addOptionHere: function (newGroup, me, callback) {
        if (newGroup.length !== 0) {
            var newOption = $($('ul', newGroup).html());//.replace(/preInputButton/g, 'inputButton').replace(/preFixButton/g, 'fixButton'));
            newOption.insertAfter($(me));
            $('.lpjs-trigger', newOption).removeAttr('disabled');
            callback(newOption);
        }
    },

    deleteOption: function (me, callback) {
        if ($(me).is('[disabled]')) {
            return;
        }
        LP.UI.warnConfirm($('#confirmOptionDelete').html(), function () {
            $(me).closest('li').remove();
            callback();
        });
    },

    deleteGroup: function (me, callback) {
        if ($(me).is('[disabled]')) {
            return;
        }
        LP.UI.warnConfirm($('#confirmGroupDelete').html(), function () {
            $(me).closest('fieldset').remove();
            callback();
        });
    },

    setPositions: function (selector, prefix) {
        if (!prefix) {
            prefix = 'opt';
        }
        var p = null;
        $(selector).each(function (index, element) {
            var $element = $(element);
            $element.html(index + 1);
            p = $element.closest('fieldset');
            $('input[name="question[' + prefix + 'Group][]"]', p).each(function () {
                this.value = index;
            });
            $('input[name="question[' + prefix + 'Position][]"]', p).each(function (pos, elm) {
                elm.value = pos;
            });
        });
    },

    checkAutoCodes: function () {
        var codesdiv = $('#lp-codes-tab');
        var codesinput = $('input#lp-auto-codes');

        if (codesdiv.length === 0 || codesinput.length === 0) {
            return;
        }

        var autocodes = codesinput.is(':checked');

        if (autocodes) {
            codesdiv.addClass('inactive');
            codesdiv.hide();
            $('input', codesdiv).attr('disabled', 'disabled');
        } else {
            codesdiv.removeClass('inactive');
            codesdiv.show();
            $('input', codesdiv).removeAttr('disabled');
        }
    }
};

LP.dlgQuestionVisible = {
    dispatching: false,

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'textblockVisible',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 750,
                    height: 500,
                    onLoad: LP.dlgQuestionVisible.onLoad,
                    beforeSubmit: LP.dlgQuestionVisible.beforeSubmit,
                    onClose: LP.dlgQuestionVisible.onClose
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.filters.init({root: '#fs-question-visibility'});
    },

    onClose: function () {
        var itemId = $('#questionId').val();
        window.Browser.send('backend/closeEditDialog/', 'itemId=' + itemId);
        return false;
    },

    beforeSubmit: function () {
        LP.filters.removeEmptyTerms($('#fs-question-visibility'));

        LP.Dialog.hideErrors();
        return LP.dlgQuestionVisible.onSave(false);
    },

    onSave: function (refresh) {
        var questionForm = $('#questionForm');
        if (questionForm.length === 0) {
            return false;
        }
        var tabResult = false;
        var url = 'backend/saveQuestionTab';
        var params = questionForm.serialize();
        // params += '&tabname=' + tabName;
        if (refresh) {
            params += '&refresh=1';
        }

        window.Browser.send(
            url,
            params,
            function (json) {
                LP.Dialog.showError(json, $('.tabError'), false);
                tabResult = true;
                return true;
            },
            function (json) {
                LP.Dialog.showError(json, $('.tabError'), false);
                tabResult = false;
                return true;
            },
            false // send syncron!
        );

        return tabResult;
    }
};
